import { NgClass } from '@angular/common';
import { Component, input, InputSignal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SkeletonLoaderComponent } from "@shared/components/ui/skeleton-loader";
import { TruncateTooltipDirective } from '@shared/directives';

@Component({
  selector: 'lib-input-wrapper',
  templateUrl: './input-wrapper.component.html',
  styleUrl: './input-wrapper.component.css',
  imports: [
    SkeletonLoaderComponent,
    TranslateModule,
    NgClass,
    TruncateTooltipDirective
  ],
})
export class InputWrapperComponent {

  /**
   * The id of the input element.
   */
  public readonly for: InputSignal<string> = input<string>('');

  /**
   * The label of the input element.
   * @default ''
   */
  public readonly label: InputSignal<string> = input<string>('');

    /**
   * The label of the input element.
   * @default null
   */
    public readonly contentRight: InputSignal<string | number> = input<string | number>(null);

  /**
   * The flag to indicate if the input is required.
   * @default false.
   */
  public readonly required: InputSignal<boolean> = input<boolean>(false);

  public readonly skeleton: InputSignal<boolean> = input<boolean>(false);

  public readonly disabled: InputSignal<boolean> = input<boolean>(false);

  public readonly truncateLabel: InputSignal<boolean> = input<boolean>(true);

  public readonly flexDirection: InputSignal<'row' | 'column'> = input<'row' | 'column'>('column');
  public readonly heightFull: InputSignal<boolean> = input<boolean>(false);
}
